import { Component, OnInit } from '@angular/core';
import { NavParams, NavController } from 'ionic-angular';
import { Usuario } from '../../entities/usuario';
import { HomePage } from '../../pages/home/home';
import { LoginPage } from '../../pages/login/login';
import { MenuHelper } from '../../utils/menu-helper';
import { Notifications } from '../../providers/notifications/notifications';
import { PedidoDAO } from '../../daos/pedido-dao';

@Component({
    selector: 'menu',
    templateUrl: './menu.html'
})
export class MenuComponent implements OnInit {
    public usuario: Usuario;
    public menuPerfil: any[] = [];
    public rootPage = HomePage;

    vChecarGrpClientePix: boolean = false;

    constructor(
        private _navParams: NavParams, 
        private _notifications: Notifications,
        private _pedidoDao: PedidoDAO, 
        private _navCtrl: NavController
    ) {
        this.usuario = this._navParams.get('usuario');
        this._notifications.prepare(this.usuario);
    }

    // It's best practice to put initialization logic in ngOnInit rather than the constructor
    ngOnInit() {
        if (this.usuario && this.usuario.CnpjEmpresaUsuario) {
            this.checarGrupoClientePix(this.usuario.CnpjEmpresaUsuario);
        } else {
            // Fallback if no CNPJ is present
            this.menuPerfil = MenuHelper.getMenuToPrifile(this.usuario.Perfil, this.vChecarGrpClientePix);
        }
    }

    checarGrupoClientePix(pCNPJ: string): void {
        this._pedidoDao.VerificarGrupoClientePix(pCNPJ)
            .then(retorno => {
                if (retorno === 'ok') {
                    this.vChecarGrpClientePix = true;
                }
                // Generate the menu ONLY AFTER the PIX check finishes
                this.menuPerfil = MenuHelper.getMenuToPrifile(this.usuario.Perfil, this.vChecarGrpClientePix);
            })
            .catch(error => {
                console.error('Error verifying PIX group:', error);
                // Ensure the menu still loads even if the API call fails
                this.menuPerfil = MenuHelper.getMenuToPrifile(this.usuario.Perfil, this.vChecarGrpClientePix);
            });          
    }

    public logout(): void {
        this._notifications.destroy(this.usuario);
        this._navCtrl.setRoot(LoginPage);
    }
}


// WEBPACK FOOTER //
// ./src/components/menu/menu.ts